import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { CmsFacade } from '@rd/cms/facades/cms.facade';
import { BannerImageSrcDirective } from '@rd/shared-legacy/widgets/banner-image/banner-image-src.directive';
import { BannerImageModule } from '@rd/shared-legacy/widgets/banner-image/banner-image.module';
import { CmsPageContentType } from '@rd/types';
import { isNotNull } from '@rd/utils/isNotNull';
import { filter, map, Observable } from 'rxjs';
import { BNZ_HOMEPAGE_BANNER_IMAGE_UNLEASH_KEY } from '../../../core/tokens/features.tokens';

@Component({
  standalone: true,
  selector: 'rd-bnz-homepage-banner-image',
  template: `
    <ng-container
      *ngIf="displayHomepageBanner$ | async; else defaultHomepageImage">
      <ng-container
        *ngIf="
          bannerContent$ | async as bannerContent;
          else defaultHomepageImage
        ">
        <img
          class="hidden h-full w-full object-cover object-[0_75%] lg:block"
          alt="Desktop banner image"
          [src]="bannerContent.desktopImageUrl" />
        <img
          class="h-full w-full object-cover object-[0_75%] lg:hidden"
          alt="'Mobile banner image'"
          [src]="bannerContent.mobileImageUrl" />
      </ng-container>
    </ng-container>

    <ng-template #defaultHomepageImage>
      <rd-banner-image
        class="[&_img]:object-[0_75%]"
        [bannerSrc]="{
          desktop: 'rd_banner',
          mobile: 'rd_banner'
        }">
      </rd-banner-image>
    </ng-template>
  `,
  imports: [BannerImageSrcDirective, BannerImageModule, CommonModule],
})
export class BnzHomepageBannerImageComponent {
  private cmsFacade = inject(CmsFacade);
  private unleashService = inject(UnleashService);

  isHomepageBannerImageEnabled = this.unleashService.isEnabled(
    BNZ_HOMEPAGE_BANNER_IMAGE_UNLEASH_KEY,
  );

  bannerContent$: Observable<CmsPageContentType> = this.cmsFacade
    .getContentByName({
      pageName: 'bnz--homepage-banner-image',
      pageType: 'campaignbanner',
      locale: 'en-AU',
    })
    .pipe(filter(isNotNull));

  homepageBannerFetchingError$: Observable<boolean> = this.cmsFacade
    .getContentErrorByName('homepage-banner-image')
    .pipe(map((error) => !!error));

  displayHomepageBanner$: Observable<boolean> =
    this.homepageBannerFetchingError$.pipe(
      map((error) => this.isHomepageBannerImageEnabled && !error),
    );
}
